var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-player__subtitles"},_vm._l((_vm.lines),function(line){return _c('div',[_c('p',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(line),expression:"line"}]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }